import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=0cae9474&scoped=true&"
import script from "./StoryCard.vue?vue&type=script&lang=js&"
export * from "./StoryCard.vue?vue&type=script&lang=js&"
import style0 from "./StoryCard.vue?vue&type=style&index=0&id=0cae9474&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae9474",
  null
  
)

export default component.exports